import { Route } from "react-router-dom"
import { BrowserRouter, Routes } from "react-router-dom"
import HomePage from "../pages/Homepage"
import { Footer } from "../components/Footer"
import { NavBar } from "../components/Navbar"
import ProductPage from "../pages/ProductsPage"
import OpalCam from "../components/Opal"
import Career from "../components/CareerPage"
import ContactPage from "../components/ContactPage"
import IndustriesItems from "../components/IndustryItems"
import StarTracker from "../components/StarTracker";

const Navigation = () => {
    return(
        <BrowserRouter>
        <NavBar/>
        <Routes>
            <Route path="/" element={<HomePage/>}/>
            <Route path="/products" element={<ProductPage/>}/>
            <Route path="/opal" element={<OpalCam/>}/>
            <Route path="/startracker" element={<StarTracker />} />
            <Route path="/career" element={<Career/>}/>
            <Route path="/company" element={<ContactPage/>}/>
            <Route path="/industries" element={<IndustriesItems/>}/>
        </Routes>
        <Footer/>
        </BrowserRouter>
    )
}

export default Navigation